import { asyncSerializer, Serializer } from '@lib/store';
import { getMealInitialState } from './get-meal.reducer';
import { GetMealState } from './get-meal.state';

export const getMealStorageSerializer = asyncSerializer;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMealStorageDeserializer = (rawObject: any) => {
  return {
    ...getMealInitialState,
    model: rawObject && rawObject.model ? rawObject.model : null,
  } as GetMealState;
};

export const getMealStorageSync: Serializer<GetMealState> = {
  serialize: getMealStorageSerializer,
  deserialize: getMealStorageDeserializer,
};
